module.exports = __webpack_public_path__ + "img/s2-hx-8.fdb912a8.png";